module.exports = __webpack_public_path__ + "static/media/modalRegister.76263925.jpg";